export default "__VITE_ASSET__BQDtgqDQ__"